module.exports = __webpack_public_path__ + "static/media/amazonus-button.6d36dc19.png";